import { defaults, mande, MandeInstance } from "mande";

export interface ApiResponse< T > {
    data: T
}

export interface Pagination {
    total: number
    limit: number
    offset: number
    total_pages: number
    current_page: number
    next_url: string
}

export interface ApiResponsePaginated< T > extends ApiResponse< T > {
    pagination: Pagination
}

export function buildMande( endpoint: string ): MandeInstance {
    return mande( endpoint, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    } );
}

export function setToken( token: string | null ): void {
    defaults.headers.Authorization = `Bearer ${ token }`;
}

export function clearToken(): void {
    delete defaults.headers.Authorization;
}